import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrow from '@fortawesome/fontawesome-free-solid/faLongArrowAltRight';
import { getItemById, isMobile, isTablet } from '../lib/util';
import Config from '../config/config';

const ProductIntroductionLinkSwiper = (props) => {
  const { dataArr, products, extraClass } = props;
  const suggestionSwiperParams = {
    slidesPerView: isMobile() ? 1 : 3,
    spaceBetween: isTablet() ? 5 : 50,
    // slidesPerGroup: 3,
    shouldSwiperUpdate: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  return (
    <Swiper containerClass={`swiper-container ${extraClass}`} {...suggestionSwiperParams}>
      {dataArr.map((elem) => {
        const tempProduct = getItemById({
          id: elem.product_ID,
          array: products,
          key: 'product_ID',
        });

        return (
          <div key={`accessories-${tempProduct.product_ID}`}>
            <div className="image-margin-wrapper">
              <figure className="image is-square">
                <div
                  style={{ backgroundImage: `url(${Config.apiUrl}${tempProduct.image[0].url})` }}
                  className="slide-product-image"
                />
              </figure>
              <Link className="product-link" to={`/product/${tempProduct.product_ID}`}>
                <span className="product-link__text">{`${tempProduct.title} ${tempProduct.chinese_title}`}</span>
                <FontAwesomeIcon className="product-link-icon" icon={faArrow} />
              </Link>
            </div>
          </div>
        );
      })}
    </Swiper>
  );
};

ProductIntroductionLinkSwiper.propTypes = {
  product: PropTypes.shape({
    image: PropTypes.arrayOf(PropTypes.object),
  }),
};

ProductIntroductionLinkSwiper.defaultProps = {
  product: {
    image: [],
  },
};

export default ProductIntroductionLinkSwiper;



// WEBPACK FOOTER //
// ./src/components/ProductIntroductionLinkSwiper.js